import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3ecbfb8c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3ecbfb8c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecbfb8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ecbfb8c')) {
      api.createRecord('3ecbfb8c', component.options)
    } else {
      api.reload('3ecbfb8c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3ecbfb8c&scoped=true", function () {
      api.rerender('3ecbfb8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NewCom/WkUserSelect/index.vue"
export default component.exports